import React from "react"
import classnames from "classnames"
import styles from "./InputRange.less"
import ReactInputRange from 'react-input-range';

class InputRange1 extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      value: { min: props.min, max: props.max },
    }

    // for testing purposes
    if (process && process.env && process.env.NODE_ENV === 'test') {
      this.random = 1
    } else {
      this.random = Math.random()
    }
  }

  componentDidMount() {
    const { onChange = () => { } } = this.props
    const { value: { min, max } } = this.state

    onChange({ min, max })
  }

  _onChange = (value) => {
    const { onChange = () => { } } = this.props

    onChange({ min: value.min, max: value.max })
  }

  render() {
    const { min, max, step } = this.props
    const { value } = this.state

    return (
      <div
        className={classnames({
          [styles.InputRange]: true
        })}>

        <ReactInputRange
          maxValue={max}
          minValue={min}
          step={step}
          value={value}
          formatLabel={value => `${value/1000}k`}
          classNames={{
            activeTrack: styles.activeTrack,
            disabledInputRange: styles.disabledInputRange,
            inputRange: styles.inputRange,
            labelContainer: styles.labelContainer,
            maxLabel: styles.maxLabel,
            minLabel: styles.minLabel,
            slider: styles.slider,
            sliderContainer: styles.sliderContainer,
            track: styles.track,
            valueLabel: styles.valueLabel
          }}
          onChange={value => this.setState({ value })}
          onChangeComplete={value => this._onChange(value)} />
      </div>
    )
  }
}

export default InputRange1



// WEBPACK FOOTER //
// ./src/AtomicComponents/InputRange/InputRange.jsx